import { useQuery } from '@tanstack/react-query';
import { dataService, Site } from '../services/data';

export function useSites(organizationId?: string) {
  return useQuery<Site[], Error>({
    queryKey: ['sites', organizationId],
    queryFn: () => dataService.getSites(organizationId),
  });
}

export function useSite(id: string | undefined) {
  return useQuery<Site, Error>({
    queryKey: ['sites', id],
    queryFn: () => dataService.getSite(id!),
    enabled: !!id,
  });
}
